<nav #navbar class="navbar active">
  <div class="container-fluid">
    <div class="navbar-header">
      <a href="#" onClick="return false;" class="navbar-toggle collapsed"
        (click)="isNavbarCollapsed = !isNavbarCollapsed" aria-expanded="false"></a>
      <a href="#" onClick="return false;" class="bars" (click)="mobileMenuSidebarOpen($event,'overlay-open')"></a>
      <a class="navbar-brand" routerLink={{homePage}}>
        @if (branding) {
          <img [src]="branding.logoDarkUrl || 'assets/images/assetvio-logo-dark.png'" class="navbar-logo navbar-logo-white" [alt]="branding.name" />
          <img [src]="branding.logoWhiteUrl || 'assets/images/assetvio-logo-white.png'" class="navbar-logo navbar-logo-dark" [alt]="branding.name" />
          <img [src]="branding.faviconUrl || 'assets/images/assetvio-icon-128-128.png'" class="navbar-icon-img" [alt]="branding.name" />
        } @else {
          <img src="assets/images/assetvio-logo-dark.png" class="navbar-logo navbar-logo-white" alt="" />
          <img src="assets/images/assetvio-logo-white.png" class="navbar-logo navbar-logo-dark" alt="" />
          <img src="assets/images/assetvio-icon-128-128.png" class="navbar-icon-img" alt="" />
        }
      </a>
    </div>
    <div class="collapse navbar-collapse" [ngClass]="isNavbarCollapsed ? '' : 'show'">
      <ul class="float-start collapse-menu-icon">
        <li class="collapseBtn">
          <button mat-icon-button (click)="callSidemenuCollapse()" class="sidemenu-collapse nav-notification-icons">
            <app-feather-icons [icon]="'menu'" [class]="'header-icon'"></app-feather-icons>
          </button>
        </li>
      </ul>

      <ul class="nav navbar-nav navbar-right">
        <!--Toggle Theme Button-->
        <li class="themeToggle">
          <button mat-icon-button class="nav-notification-icons" (click)="toggleTheme()">
            <app-feather-icons [icon]="isDarkTheme ?'moon':'sun'" [class]="'header-icon'"></app-feather-icons>
          </button>
        </li>
        <!-- Full Screen Button -->
        <li class="fullscreen">
          <button mat-icon-button class="nav-notification-icons" (click)="callFullscreen()">
            <app-feather-icons [icon]="'maximize'" [class]="'header-icon'"></app-feather-icons>
          </button>
        </li>
        <!-- #END# Full Screen Button -->
        <li class="languageMenu">
          <button mat-icon-button [matMenuTriggerFor]="languagemenu" class="lang-dropdown nav-notification-icons"> @if
            (flagvalue !== undefined) {
            <img src="{{flagvalue}}" height="16">
            }
            @if (flagvalue === undefined) {
            <img src="{{defaultFlag}}" height="16">
            }</button>
          <mat-menu #languagemenu="matMenu" class="lang-item-menu">
            @for (item of listLang; track item) {
            <div class="lang-item">
              <button mat-menu-item class="dropdown-item lang-item-list"
                (click)="setLanguage(item.text, item.lang, item.flag)"
                [ngClass]="{'active': langStoreValue === item.lang}">
                <img src="{{item.flag}}" class="flag-img" height="12"> <span class="align-middle">{{item.text}}</span>
              </button>
            </div>
            }
          </mat-menu>
        </li>
        <!-- #START# Notifications-->
        <li class="nav-item btnNotification" ngbDropdown>
          <button mat-icon-button [matMenuTriggerFor]="notificationMenu" class="nav-notification-icons">
            <app-feather-icons [icon]="'bell'" [class]="'header-icon'"></app-feather-icons>
            @if (unreadCount > 0) {
            <span class="label-count bg-orange">{{unreadCount > 99 ? '99+' : unreadCount}}</span>
            }
          </button>
          <mat-menu #notificationMenu="matMenu" class="nfc-menu">
            <div class="nfc-header">
              <h5 class="mb-0">{{'NOTIFICATIONS.HEADER.TITLE' | translate}}</h5>
              <a class="nfc-mark-as-read" (click)="markAllAsRead($event)">{{'NOTIFICATIONS.HEADER.MARK_ALL_READ' | translate}}</a>
            </div>
            <div class="nfc-dropdown">
              <ng-scrollbar style="height: 350px" visibility="hover">
                <div class="noti-list header-menu">
                  <div class="menu">
                    @for (notification of notifications; track notification.id) {
                    <button mat-menu-item (click)="markAsRead(notification, $event)" [ngClass]="[notification.status]">
                      <span class="table-img msg-user ">
                        <i class="material-icons-outlined nfc-type-icon"
                          [ngClass]="[notification.color]">{{notification.icon}}</i>
                      </span>
                      <span class="menu-info">
                        <span class="menu-title">{{notification.message}}</span>
                        <span class="menu-desc mt-2">
                          <i class="material-icons">access_time</i> {{notification.time}}
                        </span>
                      </span>
                      <span class="nfc-close" (click)="dismissNotification(notification, $event)"
                        [matTooltip]="'NOTIFICATIONS.HEADER.DISMISS' | translate">
                        <app-feather-icons [icon]="'x'" [class]="'user-menu-icons'"></app-feather-icons>
                      </span>
                    </button>
                    }
                    @if (notifications.length === 0) {
                    <div class="no-notifications" style="text-align: center; padding: 40px 20px; color: #999;">
                      <i class="material-icons" style="font-size: 48px; display: block; margin-bottom: 8px;">notifications_none</i>
                      <span>{{'NOTIFICATIONS.HEADER.EMPTY' | translate}}</span>
                    </div>
                    }
                  </div>
                </div>
              </ng-scrollbar>
            </div>
            <div class="nfc-footer">
              <a class="nfc-read-all" (click)="goToNotifications()">{{'NOTIFICATIONS.HEADER.VIEW_ALL' | translate}}</a>
            </div>
          </mat-menu>
        </li>
        <!-- #END# Notifications-->
        <li class="nav-item user_profile">
          <button mat-button [matMenuTriggerFor]="profilemenu">
            <div class="chip dropdown-toggle" ngbDropdownToggle class="">
              <span class="user-name-truncate">{{userFullName}}</span>
              <img src="{{userImg}}" class="user_img" width="32" height="32" alt="User">
            </div>
          </button>
          <mat-menu #profilemenu="matMenu" class="profile-menu">
            <div class="noti-list">
              <div class="menu ">
                <div class="user_dw_menu">
                  <div class="user-profile-info">
                    <span class="user-profile-email">{{userEmail}}</span>
                    <span class="user-profile-role">{{userRoleKey | translate}}</span>
                  </div>
                  <button mat-menu-item (click)="goToProfile()" class="user-item-list">
                    <app-feather-icons [icon]="'user'" [class]="'user-menu-icons'"></app-feather-icons>{{'GENERALITEMS.HEADER.PROFILEMENU.ACCOUNT' | translate}}
                  </button>
                  <button mat-menu-item (click)="goToDocs()" class="user-item-list">
                    <app-feather-icons [icon]="'book-open'" [class]="'user-menu-icons'"></app-feather-icons>{{'GENERALITEMS.HEADER.PROFILEMENU.DOCS' | translate}}
                  </button>
                  <button mat-menu-item (click)="goToAbout()" class="user-item-list">
                    <app-feather-icons [icon]="'info'" [class]="'user-menu-icons'"></app-feather-icons>{{'GENERALITEMS.HEADER.PROFILEMENU.ABOUT' | translate}}
                  </button>         
                  <button mat-menu-item (click)="logout()" class="user-item-list">
                    <app-feather-icons [icon]="'log-out'" [class]="'user-menu-icons'"></app-feather-icons>{{'GENERALITEMS.AUTH.LOGOUT' | translate}}
                  </button>
                </div>
              </div>
            </div>
          </mat-menu>
        </li>
        <!-- #END# Tasks -->
      </ul>
    </div>
  </div>
</nav>
